<template>
  <div class="home">
    <form>
      <img src="../assets/logo.png" alt="" />
      <v-text-field
        label="Email"
        filled
        clearable
        prepend-inner-icon="mdi-account"
        v-model="email"
      ></v-text-field>
      <v-text-field
        label="Пароль"
        type="password"
        filled
        prepend-inner-icon="mdi-key"
        v-model="pass"
      ></v-text-field>
      <v-btn depressed color="primary" @click="auth">
        <v-icon left>mdi-login-variant</v-icon> Войти</v-btn
      >
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Home",
  data: () => ({
    email: "",
    pass: "",
  }),
  methods: {
    auth() {
      let data = {
        email: this.email,
        password: this.pass,
      };
      axios.post(`${process.env.VUE_APP_AXIOS}/user`, data).then((res) => {
        if (res.status == 200) {
          localStorage.setItem("token", res.data.token);
          this.$router.push("/admin");
        }
        // console.log(res.data);
      });
    },
  },
};
</script>
